import {QRCodeItemPanels} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-QR-options/poster-editing-QR-options.types';
import {useEffect} from 'react';
import {useGetKeyFromQRItem} from '@Hooks/poster-editor/useGetKeyFromQRItem';

export function useIsOpenedQRPanelValid(currentlyOpenedColorPanel: QRCodeItemPanels, setCurrentlyOpenedPanel: (newVal: QRCodeItemPanels) => void): void {
  const isBGTransparent = useGetKeyFromQRItem('isBackgroundTransparent');

  useEffect((): void => {
    if (isBGTransparent && currentlyOpenedColorPanel === QRCodeItemPanels.BACKGROUND) {
      setCurrentlyOpenedPanel(QRCodeItemPanels.NONE);
    }
  }, [isBGTransparent]);

  return;
}
